import { Directive, HostListener, inject } from '@angular/core';
import { GoogleAnalyticsService } from '@lx/shared/google-analytics';
import { GoogleAnalyticsEventEnum } from '../google-analytics';

@Directive({
  standalone: true,
  selector: '[lxGAClickBackEvent]',
})
export class GoogleAnalyticsClickBackEventDirective {
  private readonly googleAnalyticsService = inject(GoogleAnalyticsService);

  @HostListener('click', ['$event']) onClick(event: MouseEvent) {
    this.googleAnalyticsService.trackClickEvent(GoogleAnalyticsEventEnum.QuoteBack);
    event.stopImmediatePropagation();
  }
}
